import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToLocalDate } from "../../../utils/dateConvert";
import { downloadCSVFile } from "../../../api/apiClient";

function LogTable(props) {
  let assetName = props.assetCustomerName;
  let assetId = props.assetId;
  let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';
  let tempAEnabled = props.tempAEnabled;
  let tempBEnabled = props.tempBEnabled;
  const data = (
    <Table responsive striped>
      <thead>
        <tr className="nowwrapTH">
          <th>Date</th>
          {tempAEnabled && (<th>Temp A</th>)}
          {tempBEnabled && (<th>Temp B</th>)}

          <th>Fridge</th>
          <th>Ignition</th>
        </tr>
      </thead>
      <tbody>
        {props.logTable.map((exception, index) => {
          return (
            <tr>
              <td>{utcToLocalDate(exception.date)}</td>
              {tempAEnabled && (<td>{exception.tempA}</td>)}
              {tempBEnabled && (<td>{exception.tempB}</td>)}
              <td>{exception.fridgeStatus ? "On" : "Off"}</td>
              <td>{exception.ignitionStatus ? "On" : "Off"}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );

  const handleDownloadExcel = () => {
    downloadCSVFile(props.logTable, "Temperature_Logs", assetName, timeZone, assetId);
  };

  return (
    <ToggleBar
      caption="Logs"
      icon="fa fa-table"
      color="#A94442"
      content={data}
      download={handleDownloadExcel}
    />
  );
}

export default LogTable;
